import { watch } from 'vue';
import { useBroadcastChannel } from '@vueuse/core';
import { loadUserDetails, loadPermissions } from '../app/initialLoader';

const USER_DETAILS_SYNC_CHANNEL = 'user-details-sync';

type UserDetailsSyncMessage = { refresh: boolean };

export const useUserDetailsSync = () => {
    const { post, data, isSupported } = useBroadcastChannel<
        UserDetailsSyncMessage,
        UserDetailsSyncMessage
    >({
        name: USER_DETAILS_SYNC_CHANNEL,
    });

    watch(data, async (message) => {
        if (message?.refresh && isSupported.value) {
            await Promise.all([loadUserDetails(), loadPermissions()]);
        }
    });

    const broadcastRefresh = () => {
        if (isSupported.value) {
            try {
                post({ refresh: true });
            } catch (error) {
                console.warn('Failed to broadcast user details refresh:', error);
            }
        }
    };

    return { broadcastRefresh };
};
